import { Box, MantineBreakpoint } from '@mantine/core';
import React, { ReactNode } from 'react';

interface NavbarContainerProps {
    hiddenFrom?: MantineBreakpoint;
    visibleFrom?: MantineBreakpoint;
    children: ReactNode;
}

function NavbarContainer({ hiddenFrom, visibleFrom, children }: NavbarContainerProps) {
    return (
        <Box style=
            {{
                display: "flex",
                height: "100vh",
                flexDirection: "column",
                padding: "16px",
            }}
            hiddenFrom={hiddenFrom}
            visibleFrom={visibleFrom}
        >
            {children}
        </Box>
    )
};

export default NavbarContainer;